import React from 'react';
import { Link } from 'react-router-dom';
import { useBlogs } from '../../../common/BlogContext';

function Slider() {
  const { blogs, loading } = useBlogs();

  const featured = [...blogs]
    .filter((b) => b.publish_date)
    .sort((a, b) => new Date(b.publish_date) - new Date(a.publish_date))
    .slice(0, 2);

  // Still loading — show nothing so swiper initialises after data is ready
  if (loading) {
    return (
      <section className="tc-main-slider-style1">
        <div className="container-fluid">
          <div className="main-slider">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div className="slider-card">
                  <div style={{ background: '#1a1a2e', height: '100%', width: '100%', position: 'absolute', inset: 0 }} />
                  <div className="content">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-7">
                          <div className="info">
                            <h2 className="fsz-45 fw-500" style={{ color: '#fff', opacity: 0.4 }}>
                              Loading…
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (featured.length === 0) {
    return (
      <section className="tc-main-slider-style1">
        <div className="container-fluid">
          <div className="main-slider">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div className="slider-card">
                  <div style={{ background: '#1a1a2e', height: '100%', width: '100%', position: 'absolute', inset: 0 }} />
                  <div className="content">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-7">
                          <div className="info">
                            <h2 className="fsz-45 fw-500" style={{ color: '#fff' }}>
                              No articles yet —{' '}
                              <Link to="/admin" style={{ color: '#f59e0b' }}>
                                Add one in Admin
                              </Link>
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="tc-main-slider-style1">
      <div className="container-fluid">
        <div className="main-slider">
          <div className="swiper-wrapper">
            {featured.map((item, i) => {
              const tags = item.category
                ? item.category.split(/[,\s]+/).filter(Boolean)
                : [];

              return (
                <div key={item.id ?? i} className="swiper-slide">
                  <div className="slider-card">
                    {item.img && (
                      <img src={item.img} alt={item.title} className="bg" />
                    )}
                    <div className="content">
                      <div className="container">
                        <div className="row">
                          <div className="col-lg-7">
                            <div className="info">
                              <div className="date fsz-12 text-uppercase mb-30">
                                {tags[0] && <a href="#"> {tags[0]} </a>}
                                {tags[0] && item.publish_date && (
                                  <span className="circle icon-3 bg-white rounded-circle mx-3"></span>
                                )}
                                {item.publish_date && <a href="#"> {item.publish_date} </a>}
                              </div>
                              <h2 className="fsz-45 fw-500">
                                <Link to={`/blog/${item.id}`} className="hover-orange1">
                                  {item.title}
                                </Link>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="swiper-pagination"></div>
          <div className="arrows">
            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Slider;